import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { products as staticProducts } from "@/data/products";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const merge = (overrides) =>
  staticProducts.map((p) => {
    const o = overrides[p.id] || {};
    const merged = { ...p, ...o };
    if (merged.image && merged.image.startsWith("/api/")) merged.image = `${BACKEND}${merged.image}`;
    return merged;
  });

const Ctx = createContext({ products: staticProducts, refresh: () => {}, isCustomized: false });

export function CatalogProvider({ children }) {
  const [products, setProducts] = useState(staticProducts);
  const [isCustomized, setIsCustomized] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/product-overrides`);
      const overrides = await res.json();
      setProducts(merge(overrides));
      setIsCustomized(Object.keys(overrides).length > 0);
    } catch (e) {}
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <Ctx.Provider value={{ products, refresh, isCustomized }}>{children}</Ctx.Provider>;
}

export const useCatalog = () => useContext(Ctx);
export const getById = (list, id) => list.find((p) => p.id === id);
